/**
 * Contact company url.
 * @type {string}
 */
export const CONTACT_COMPANY_URL = 'https://gtres.com/contacto/#cta';

/**
 * Company name.
 * @type {string} Company name.
 */
export const COMPANY_NAME = 'Gtres Online S.L.';

/**
 * Company short name.
 * @type {string} Company short name.
 */
export const COMPANY_SHORT_NAME = 'Gtres';

/**
 * Extension ID for the Chrome Web Store.
 * @type {string}
 */
export const CHROME_EXTENSION_ID = 'cpcoimioheifeebimappllknngfenhol';

/**
 * Chrome extension URL.
 * @type {string}
 */
export const CHROME_EXTENSION_URL =
    'https://chromewebstore.google.com/detail/gtres-ai/cpcoimioheifeebimappllknngfenhol?hl=es';

/**
 * @type {string} - Main logo dark image.
 */
export const MAIN_COMPANY_LOGO_DARK_IMG = 'assets/company/img/logos/Main_logo_dark.svg';

/**
 * @type {string} - GTres legal url.
 */
export const GTRES_LEGAL_URL = 'https://gtres.com/aviso-legal/';

/**
 * @type {string} - GTres cookies policy url.
 */
export const GTRES_COOKIES_POLICY_URL = 'https://gtres.com/politica-de-cookies-ue/';
